import React from "react"
import Swal from "sweetalert2"
import withReactContent from "sweetalert2-react-content"

const MySwal = withReactContent(Swal)

const ACTIVATE_INFO = [
  {
    icon: "fas fa-users",
    title: "Adaptation à l'audience",
    description: "Les publicités s'adapteront automatiquement selon l'âge et le genre de l'audience.",
  },
  {
    icon: "fas fa-image",
    title: "Ressource par défaut requise",
    description: "Une ressource par défaut est nécessaire comme contenu de repli.",
  },
  {
    icon: "fas fa-pause-circle",
    title: "Playlist standard en pause",
    description: "La rotation standard sera mise en pause tant que la diffusion intelligente est active.",
  },
]

const DEACTIVATE_INFO = [
  {
    icon: "fas fa-sync-alt",
    title: "Rotation standard",
    description: "Les publicités seront diffusées en rotation standard.",
  },
  {
    icon: "fas fa-save",
    title: "Configurations conservées",
    description: "Vos configurations de diffusion intelligente seront conservées mais inactives.",
  },
]

function ToggleDialogContent({ intro, items }) {
  return (
    <div className="ai-access-dialog">
      <div className="ai-access-dialog__icon-wrapper">
        <div className="ai-access-dialog__icon">
          <i className="fas fa-crosshairs"></i>
        </div>
      </div>

      <p className="ai-access-dialog__intro">{intro}</p>

      <div className="ai-access-dialog__features">
        {items.map((item) => (
          <div key={item.title} className="ai-access-dialog__feature">
            <div className="ai-access-dialog__feature-icon">
              <i className={item.icon}></i>
            </div>
            <div>
              <div className="ai-access-dialog__feature-title">{item.title}</div>
              <div className="ai-access-dialog__feature-desc">{item.description}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export const openActivateAiDialog = () => {
  return MySwal.fire({
    html: (
      <ToggleDialogContent
        intro="Activer la diffusion intelligente pour que les publicités s'adaptent automatiquement au profil de l'audience."
        items={ACTIVATE_INFO}
      />
    ),
    showConfirmButton: true,
    confirmButtonText: "Activer la diffusion intelligente",
    confirmButtonColor: "#133D94",
    showCancelButton: true,
    cancelButtonText: "Annuler",
    showCloseButton: true,
    width: "520px",
    customClass: {
      popup: "ai-access-dialog__popup",
    },
  })
}

export const openDeactivateAiDialog = () => {
  return MySwal.fire({
    html: (
      <ToggleDialogContent
        intro="Revenir au mode standard et désactiver la diffusion intelligente."
        items={DEACTIVATE_INFO}
      />
    ),
    showConfirmButton: true,
    confirmButtonText: "Revenir au mode standard",
    confirmButtonColor: "#133D94",
    showCancelButton: true,
    cancelButtonText: "Annuler",
    showCloseButton: true,
    width: "520px",
    customClass: {
      popup: "ai-access-dialog__popup",
    },
  })
}
